module.exports = __webpack_public_path__ + "img/technology_big1.eead2775.png";